import { Link } from "react-router-dom";
import { Logo } from "./Nav";

const cols = [
  { title: "Product", links: [["Destinations", "/destinations"], ["How it works", "/how-it-works"], ["For applicants", "/applicants"], ["For agencies", "/agencies"], ["Pricing", "/#pricing"]] },
  { title: "Apply", links: [["Start my visa", "/register"], ["Tourist visas", "/destinations"], ["Student visas", "/destinations"], ["Family applications", "/register"]] },
  { title: "Learn", links: [["Preparation guides", "/help"], ["How it works", "/how-it-works"], ["FAQ", "/#faq"], ["Help centre", "/help"]] },
  { title: "Company", links: [["About Holavisto", "/help"], ["Contact", "/consultation"], ["Careers", "/help"]] },
  { title: "Legal", links: [["Privacy", "/privacy"], ["Terms", "/terms"], ["Refund policy", "/terms"], ["Cookies", "/privacy"]] },
];

export default function Footer() {
  return (
    <footer className="border-t border-hborder bg-navy text-white">
      <div className="mx-auto max-w-page px-4 py-14 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-7">
          <div className="lg:col-span-2">
            <Logo dark />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/70">
              Holavisto helps travellers prepare their visa applications with organized documents, guided preparation, intelligent checks and real human support.
            </p>
            <p className="mt-4 max-w-xs text-xs leading-relaxed text-white/50">
              We are a private visa preparation service and technology platform. We are not a government service and we do not make visa decisions.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h3 className="text-sm font-semibold uppercase tracking-wider text-white/90">{c.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={label + to}>
                    <Link to={to} className="text-sm text-white/65 transition-colors hover:text-brandyellow">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-sm text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Holavisto. All rights reserved.</p>
          <p className="text-xs">Visa decisions are made by the relevant government authority. Holavisto provides preparation and support only.</p>
        </div>
      </div>
    </footer>
  );
}
